module.exports = __webpack_public_path__ + "img/logo-home.f338755e.png";